import { loginPath } from 'components/page/Boarding/boarding.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const useAuthorizationBaseUrl = (
  authorizedUrl: string,
  thenUrl?: string
): string => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )
  const authorizationPath = useAuthorizationPath()
  const baseAuthorizationUrl = authorizationPath.endsWith(loginPath)
    ? mergeAllUrls(authorizationPath, thenUrl!)
    : authorizationPath

  return authorized ? authorizedUrl : baseAuthorizationUrl
}
